import { Outlet } from "react-router-dom";
import "./styles.css";

export default function Layout() {

  return (
    <>

      <Outlet />
    </>
  );
}